/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import controlVersion from 'config/version.json';

export default {controlCenterVersion: controlVersion['version']};